module.exports = __webpack_public_path__ + "img/service-img-1.cc8f5fcd.png";